import moment from 'moment';

export function formatTime(duration: moment.Duration): string {
    if (duration == null) {
        return '';
    }
    
    return moment.utc(duration.as('milliseconds')).format('HH:mm');
}